import { Box, Grid, Tooltip } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { REACT_CREATE_DISCOUNT } from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getDiscountList } from "../../slices/Discount/DiscountSlice";
import CommonUtil from "../../Util/CommonUtils";

export default function Discount() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openEditDiscount, setOpenEditDiscount] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));

  let history = useHistory();

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  useEffect(() => {
    loadDiscountData(paging);
  }, [paging]);

  const loadDiscountData = (paging) => {
    dispatch(getDiscountList(Object.assign(paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && !CommonUtil.isEmpty(data.data)) {
          setRows(data.data.discounts);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      });
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    history.push({
      pathname: REACT_CREATE_DISCOUNT,
    });
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const handleEditDiscount = (params) => {
    setOpenEditDiscount(true);
    setEditRowData(params);
    history.push({
      pathname: REACT_CREATE_DISCOUNT,
      state: params.row,
    });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };
  const renderCellCreateAt = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.createdAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : "YYYY-MM-DD HH:mm"
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const columns = React.useMemo(
    () => [
      {
        field: "user.profile",
        headerName: "",
        sortable: false,
        width: 5,
      },
      {
        field: "name",
        headerName: t("CUSTDATABLE26"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => params.row.name,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "discount",
        headerName: t("CUSTDATABLE29"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => params.row.discountValue,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "date",
        headerName: t("CUSTDATABLE30"),
        flex: 1,
        minWidth: 100,
        renderCell: renderCellCreateAt(
          formatDate(companySettings?.adminAndDealerDateFormat)
        ),
      },

      {
        field: "status",
        headerName: t("CUSTDATABLE07"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) =>
          params.row.status === true ? "ACTIVE" : "INACTIVE",
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },
    ],
    []
  );

  return (
    <>
      <HeaderToolbar title={t("DISCOUNT")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Tooltip title={t("ADDDISCOUNT")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
      </Box>
      <Grid item style={{ width: "100%", height: 300 }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          pageCount={totalPages}
          count={totalRecords}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </Grid>
    </>
  );
}
